/**
 * Validator keys for required errors on the Regulator Info page.
 */
export const RegulatorInfoValidationKey = {
    alienRulingRequired: 'alienRulingRequired',
    atLeastOneRadioServiceTypeRequired: 'atLeastOneRadioServiceTypeRequired',
    atLeastOneRadioServiceOfferingRequired:
        'atLeastOneRadioServiceOfferingRequired',
};
